import * as React from "react";
import { useRouter } from "next/router";
import { createOrchestrator } from "@nju/data-access-portal-orchestrator";
import { portalRoutes } from "@nju/routes";
import { Button } from "@nju/ui";

type IStates = "IDLE" | "LOADING" | "ERROR" | "DONE";

export function FSecureReactivationButton() {
  const [currentState, setCurrentState] = React.useState<IStates>("IDLE");
  const router = useRouter();

  const onButtonClick = async () => {
    setCurrentState("LOADING");

    createOrchestrator("NJU_FSECURE_REACTIVATION", {}).then((result) => {
      if (result.isOk) {
        router.push(
          portalRoutes.mojeKonto.mojeUslugi.reaktywacja.index.get({
            mode: "fsecure",
          }),
        );

        return setCurrentState("DONE");
      }

      router.push(portalRoutes.ups.get());
      return setCurrentState("ERROR");
    });
  };

  return (
    <Button
      isLoading={currentState === "LOADING" || currentState === "DONE"}
      onPress={() => {
        return onButtonClick();
      }}
    >
      włącz usługę
    </Button>
  );
}
